export default __webpack_public_path__ + "static/media/ticket-active.5069b194.svg";